import { IsISO8601, Length, Matches } from "class-validator";
/**
 * A calendar date as `YYYY-MM-DD`, no time. Only compiles on a property typed `DateString`.
 * Strict ISO 8601 rejects impossible dates; the character check rules out week dates like `2026-W44-5`.
 */
export function IsValidDateString() {
    return (target, propertyKey) => {
        for (const decorator of [IsISO8601({ strict: true }), Length(10, 10), Matches(/^[\d-]+$/)]) {
            decorator(target, propertyKey);
        }
    };
}
//# sourceMappingURL=is-valid-date-string.js.map